import { useDispatch } from "react-redux";
import React, { useEffect } from "react";

import "../dashboard/dashboard.scss";
import { actions } from "../../redux/actions";
import CardEnvioDados from "./components/cardEnvioDados/cardEnvioDados";
import CardCertificadosAtivos from "./components/cardCertificadosAtivos/cardCertificadosAtivos";
import CardUltimosDadosInformados from "./components/CardUltimosDadosInformados/CardUltimosDadosInformados";
import CardGraficos from "./components/cardGraficos/cardGraficos";

const Dashboard: React.FC<any> = (props) => {
  const dispatch = useDispatch();

  const verifyToken = () => {
    if (window.location.href.indexOf("localhost") < 0) {
      const currentTokenDateString =
        localStorage.getItem("currentTokenDate") || "";

      let currentDate = new Date();
      let currentTokenDate = new Date(currentTokenDateString);

      // the time difference of two dates
      var Difference_In_Time =
        currentDate.getTime() - currentTokenDate.getTime();

      // number of days between two dates
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      if (Difference_In_Days > 2) {
        window.location.href = "https://www.ancp.org.br/";
      }
    }
  };

  useEffect(() => {
    dispatch(actions.addNewTitle("Dashboard"));
    dispatch(actions.addNewPageFilter("filtro"));
    dispatch(actions.addNewHelpText(null));
    verifyToken();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="my-3" style={{ marginLeft: 68 }}>
        <div className="row row-cols-1 row-cols-sm-1 row-cols-lg-2 g-3 g-lg-0">
          <div className="col-lg-8">
            <div className="row row-cols-1 row-cols-sm-1 row-cols-lg-2 g-3 g-lg-4">
              <div className="col-lg-8">
                <CardEnvioDados />
              </div>
              <div className="col-lg-4">
                <CardCertificadosAtivos />
              </div>
              <div className="col-lg-12">
                <div>
                  <p className="fw-bold fs-18px text-dark-light mb-1">
                    Gráficos
                  </p>
                  <p className="border mb-2" style={{ width: 161 }}>
                    {" "}
                  </p>
                </div>
                <div className="d-flex mb-4">
                  <button className="global-btn-outline graphics-btn">
                    Gráfico 1
                  </button>
                  <button className="global-btn-outline graphics-btn">
                    Gráfico 2
                  </button>
                  <button className="global-btn-outline graphics-btn">
                    Gráfico 3
                  </button>
                  <button className="global-btn-outline graphics-btn">
                    Gráfico 4
                  </button>
                </div>
                <CardGraficos />
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="row g-sm-3 g-0">
              <div className="col">
                <CardUltimosDadosInformados />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
